"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.styles = void 0;
var stylex = _interopRequireWildcard(require("@stylexjs/stylex"));
var _tokensStylex = require("web/shared/tokens.stylex.js");
var _imageCandidateMotionStylex = require("web/shared/imageCandidates/imageCandidateMotion.stylex.js");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
/**
 * Styles for a candidate's actions, the same wherever one is acted on:
 * white pills with a shadow, the icon ones full circles.
 */ // Every action's height, and an icon action's width too: a circle.
const ACTION_SIZE = "2.25rem"; // An action's border at rest: there to be seen, so a hover only darkens
// it rather than seeming to draw it.
const RESTING_BORDER = "rgba(17, 17, 17, 0.35)"; // The "Selected" mark landing where the choose control was: it pops in a touch
// larger than it ends.
const markIn = "xb5xka3-B";
const styles = exports.styles = {
  row: {
    display: "x78zum5",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "x1rcpt3j",
    rowGap: null,
    columnGap: null,
    $$css: true
  },
  action: {
    display: "x3nfvp2",
    alignItems: "x6s0dn4",
    justifyContent: "xl56j7k",
    gap: "x1neeqzj",
    rowGap: null,
    columnGap: null,
    boxSizing: "x9f619",
    minHeight: "x19wm6jj",
    fontFamily: "x1wl88yq",
    fontSize: "x1nrrp6k",
    fontWeight: "xk50ysn",
    color: "x10kmngs x1qfsr1m x100nr68",
    backgroundColor: "xdgjd8o x1c3hu7l",
    borderWidth: "xdh2fpr",
    borderInlineWidth: null,
    borderInlineStartWidth: null,
    borderLeftWidth: null,
    borderInlineEndWidth: null,
    borderRightWidth: null,
    borderBlockWidth: null,
    borderTopWidth: null,
    borderBottomWidth: null,
    borderStyle: "x1y0btm7",
    borderInlineStyle: null,
    borderInlineStartStyle: null,
    borderLeftStyle: null,
    borderInlineEndStyle: null,
    borderRightStyle: null,
    borderBlockStyle: null,
    borderTopStyle: null,
    borderBottomStyle: null,
    borderColor: "x36g49h xun8cwn",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    borderRadius: "x1e6avla",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    padding: "x15ib6jl",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    boxShadow: "x19ns35v",
    cursor: "x1ypdohk xtgyt42",
    transition: "x1ajle08 x9kvfbb",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    $$css: true
  },
  chosenMark: {
    borderColor: "xs5ia2r xun8cwn",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    color: "x19p3n1p",
    cursor: "xt0e3qv",
    $$css: true
  },
  chosenMarkIn: {
    animationName: "x1sdjkje",
    animationDuration: "x9dz2be x1u6grsq",
    animationTimingFunction: "x1e7x7q8",
    animationFillMode: "x1u6ievf",
    $$css: true
  },
  iconAction: {
    width: "x1s4ejo4",
    height: "xk8t5le",
    padding: "x1717udv",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    borderRadius: "x16rqkct",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    borderTopLeftRadius: null,
    borderTopRightRadius: null,
    borderBottomLeftRadius: null,
    borderBottomRightRadius: null,
    $$css: true
  },
  viewAction: {
    color: "x10kmngs x1qfsr1m",
    borderColor: "x36g49h xun8cwn",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  deleteAction: {
    color: "x10kmngs x1xi7z25",
    borderColor: "x36g49h x1dgm8pa",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    $$css: true
  },
  deleteBlocked: {
    color: "x1y5dh6w x1v0m73a",
    backgroundColor: "xe784g3 x1priga4",
    borderColor: "xscrsms x1ils2kg",
    borderInlineColor: null,
    borderInlineStartColor: null,
    borderLeftColor: null,
    borderInlineEndColor: null,
    borderRightColor: null,
    borderBlockColor: null,
    borderTopColor: null,
    borderBottomColor: null,
    boxShadow: "xc3h61q",
    cursor: "x1h6gzvc",
    $$css: true
  }
};